/**
 * Service Manager
 * 
 * This service manages the lifecycle of all external API services
 * based on user authentication state.
 */

import binanceService from './binanceService';
import orderBookService from './orderBookService';

class ServiceManager {
  private isInitialized = false;

  /**
   * Start all services when user is authenticated
   */
  public startAllServices() {
    if (this.isInitialized) {
      return;
    }
    
    // Start Binance service
    binanceService.startService();
    
    // Start OrderBook service
    orderBookService.startService();
    
    this.isInitialized = true;
  }

  /**
   * Stop all services when user logs out
   */
  public stopAllServices() {
    if (!this.isInitialized) {
      return;
    }
    
    // Stop Binance service
    binanceService.stopService();
    
    // Stop OrderBook service
    orderBookService.stopService();
    
    this.isInitialized = false;
  }

  /**
   * Force cleanup all services (for emergency cleanup)
   */
  public forceCleanup() {
    // Force stop all services regardless of initialization state
    binanceService.disconnect();
    orderBookService.stopService();
    this.isInitialized = false;
  }

  /**
   * Check if services are running
   */
  public areServicesRunning(): boolean {
    return this.isInitialized && 
           binanceService.isServiceRunning() && 
           orderBookService.isServiceRunning();
  }

  /**
   * Get service status
   */
  public getServiceStatus() {
    return {
      isInitialized: this.isInitialized,
      binanceService: binanceService.isServiceRunning(),
      orderBookService: orderBookService.isServiceRunning()
    };
  }
}

// Export singleton instance
export const serviceManager = new ServiceManager();
export default serviceManager;
